import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

const Edit = ({ place, handleCancelClick, increment, setPlaceId }) => {
  const [place1, setPlace1] = useState(place);
  const axiosPrivate = useAxiosPrivate();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPlace1((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "jobs/place/" + place1.id + "/",
          place1,
          {
            signal: controller.signal,
          }
        );
        //isMounted && setDocuments(response.data);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    updateData();
    setPlaceId(null);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <tr>
      <td>{place.id}</td>
      <td>
        <input
          type="text"
          name="title"
          className="form-control"
          id="title"
          value={place1.title}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <textarea
          name="address"
          className="form-control"
          id="address"
          value={place1.address}
          placeholder="כתובת מדויקת"
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
